import { makeObservable, action, computed, observable } from "mobx";
class PaymentStore {
  constructor(translateStore) {
    this.translateStore = translateStore;
    makeObservable(this, {
      paymentStatus: observable,
      paymentAmount: observable,
      amountFieldState: observable,
      currentAmount: observable,
      initialAmount: observable,
      previousAmount: observable,
      parsedCurrentAmount: computed,
      paymentHasFinalStatus: computed,
      amountFieldHasError: computed,
      amountAsNumber: computed,
      amountInCents: computed,
      amountFieldErrorLabel: computed,
      hasAmountChanged: computed,
      setPaymentStatus: action,
      setInitialAmount: action,
      changeCurrentAmount: action,
      setAmountFieldState: action
    });
  }
  paymentStatus = "NEW";
  paymentAmount;
  amountFieldState = "READY_FOR_PAYMENT";
  currentAmount = "";
  initialAmount;
  previousAmount;
  get parsedCurrentAmount() {
    return this.currentAmount ? PaymentStore.parseAmount(this.currentAmount) : "0.00";
  }
  get parsedCurrentAmountByLanguage() {
    const parsedCurrentAmount = this.parsedCurrentAmount;
    if (this.translateStore.currentLanguage === "en") {
      return parsedCurrentAmount;
    }
    return parsedCurrentAmount.replace(".", ",");
  }
  get paymentHasFinalStatus() {
    return ["COMPLETED", "ERROR", "REJECTED", "NOT_FOUND"].includes(this.paymentStatus);
  }
  get amountFieldHasError() {
    return this.amountFieldErrorLabel !== "";
  }
  get amountAsNumber() {
    return Number(this.parsedCurrentAmount.replace(",", "."));
  }
  get amountInCents() {
    if (!this.paymentAmount) {
      return 0;
    }
    return Number.parseInt(PaymentStore.parseAmount((this.paymentAmount * 100).toString()));
  }
  get amountFieldErrorLabel() {
    const numberRegex = "^-?[0-9]*[\\.,]?[0-9]*$";
    if (this.currentAmount.search(numberRegex) === -1) {
      return "payment.errors.invalid-characters";
    }
    if (this.currentAmount.search("[,\\.]") !== -1 && this.currentAmount.search("[,\\.][0-9]{0,2}$") === -1) {
      return "payment.errors.too-many-decimal-places";
    }
    if (this.currentAmount === "" || this.amountAsNumber === 0) {
      return "payment.errors.not-empty";
    }
    if (this.amountAsNumber <= 0) {
      return "payment.errors.negative-number";
    }
    return "";
  }
  get hasAmountChanged() {
    return this.parsedCurrentAmount !== this.initialAmount;
  }
  setPaymentStatus(state) {
    this.paymentStatus = state;
  }
  setInitialAmount = (initialAmount) => {
    const parsedAmount = initialAmount ? PaymentStore.parseAmount(initialAmount.toString()) : "0.00";
    this.initialAmount = parsedAmount;
    this.currentAmount = parsedAmount;
    this.paymentAmount = Number(parsedAmount);
  };
  changeCurrentAmount = (newAmount) => {
    this.currentAmount = newAmount;
  };
  setAmountFieldState = (state) => {
    if (state === "EDITING") {
      this.previousAmount = this.currentAmount;
    }
    if (state === "CANCELLED") {
      this.currentAmount = this.previousAmount || "";
    }
    if (state === "READY_FOR_PAYMENT") {
      this.paymentAmount = this.amountAsNumber;
    }
    this.amountFieldState = state;
  };
  static parseAmount(amount) {
    return parseFloat(amount.replace(",", ".")).toFixed(2);
  }
}
export {
  PaymentStore as default
};
